import React, {Component} from 'react';
import { Row, Col, Label, Input } from "reactstrap";
import {IconeInformacao} from './Icones';

export default class FormInputTelefoneDDD extends Component {
    constructor(props) {
        super(props);

        this.state={
            ddd: this.props.dadoDDD ? this.props.dadoDDD : "",
            telefone: this.props.dadoTelefone ? this.props.dadoTelefone : ""
        }
    }

    handleChangeDDD = (event) => {
        let valor = event.target.value.replace(/\D/g,'');
        this.setState({ ddd: valor });
        this.props.onChangeDDD(event, event);
    };

    handleChangeTelefone = (event) => {
        let valor = event.target.value.replace(/\D/g,'');
        this.setState({ telefone: valor });
        this.props.onChangeTelefone(event, event);
    };

    // handleChange = (event, dado) => {
    //     let valor = event.target.value.replace(/\D/g,'')
    //
    //     if (this.props.limiteMaximo) {
    //         if(valor.length <= this.props.limiteMaximo){
    //             this.setState({ value: valor });
    //             this.props.onChange(event, event)
    //         }
    //     } else {
    //         this.setState({ value: valor });
    //         this.props.onChange(event, event)
    //     }
    // };

    render() {
        let tamDDD = 4; let tamTel = 8;
        return(
            <Col className={this.props.className ? this.props.className+" form-input-telefone-ddd" : "form-input-telefone-ddd"}
                xs={this.props.xs ? this.props.xs : 'auto'}
                sm={this.props.sm ? this.props.sm : 'auto'}
                md={this.props.md ? this.props.md : 'auto'}
                lg={this.props.lg ? this.props.lg : 'auto'}
                xl={this.props.xl ? this.props.xl : 'auto'} >
                <div className="w-100">
                    { this.props.titulo
                        && <Label> { this.props.titulo } { this.props.obrigatorio ? <span className="label-danger">*</span> : "" }</Label>
                    }
                    <Row>
                        <Col xs={tamDDD} sm={tamDDD} md={tamDDD} lg={tamDDD} xl={tamDDD}>
                            <Input type="text"
                                   value={ this.state.ddd }
                                   maxLength={3}
                                   onChange={ this.handleChangeDDD } />
                        </Col>
                        <Col xs={tamTel} sm={tamTel} md={tamTel} lg={tamTel} xl={tamTel}>
                            <Input type="text"
                                   value={ this.state.telefone }
                                   maxLength={10}
                                   onChange={ this.handleChangeTelefone } />
                        </Col>
                    </Row>
                </div>
                { (this.props.alerta && this.props.alerta.length>0) ? <Label className="label-danger">{ this.props.alerta }</Label> : "" }
                <div className="d-flex align-items-center">
                    { this.props.iconeInfo && <div><IconeInformacao className="pr-1" /></div> }
                    { this.props.informacoes ? <Label className="informacoes">{ this.props.informacoes }</Label> : "" }
                </div>
            </Col>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/comum/components/FormInputTelefoneDDD.js